/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Submit_Scene_Description_JobInputs */



/**
* | output |
* | --- |
* | "Submit Job" |
*
* @param {Submit_Scene_Description_JobInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const submit_scene_description_job = /** @type {((inputs?: Submit_Scene_Description_JobInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Submit_Scene_Description_JobInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Soumettre une offre d'emploi")
	if (locale === "de") return /** @type {LocalizedString} */ ("Job einreichen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Invia la tua offerta di lavoro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отправить вакансию")
	if (locale === "es") return /** @type {LocalizedString} */ ("Enviar solicitud de empleo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("提交职位")
	if (locale === "ja") return /** @type {LocalizedString} */ ("求人情報を送信する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नौकरी जमा करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Enviar vaga")
	return /** @type {LocalizedString} */ ("Submit Job")
});